<script lang="ts">
  import { is } from '@shared/lib/utils';

  export let isActive = false;

  const lineClass = 'bg-default-900 line h-px scale-y-150 w-5 origin-left duration-500 dark:bg-white';
</script>

<button class="mt-0.5 flex flex-col gap-1.5 py-1.5" on:click>
  <span class="{lineClass} {is(isActive, '-translate-y-[3.75px] translate-x-0.5 rotate-45')}"></span>
  <span class="{lineClass} {is(isActive, 'translate-x-0.5 translate-y-[3.75px] -rotate-45')}"></span>
</button>
